var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('label',{staticClass:"block"},[_c('span',{staticClass:"text-gray-700"},[_vm._v("Textarea")]),_c('textarea',{staticClass:"form-textarea mt-1 block w-full",attrs:{"rows":"3","placeholder":"Enter some long form content."}})])])
}]

export { render, staticRenderFns }